import { saveTerminalLog, createLogObject } from "../../service/terminalOutputService"

// runFields (study runs only): { run_id, code_hash }, put on every line of the saved output so
// the row joins to that run's telemetry. The output stays an array of lines: the instructor
// dashboard's pass-rate queries read it as one.
export const saveRunToDB = async (
  finalOutput,
  currentUser,
  session,
  codeSnapshot,
  runFields = null
) => {
  if (!currentUser || !session) return

  try {
    const logData = createLogObject(
      currentUser.id,
      session.id,
      runFields ? finalOutput.map((entry) => ({ ...entry, ...runFields })) : finalOutput,
      codeSnapshot
    )

    await saveTerminalLog(logData)
    console.log("Terminal run saved to DB")

  } catch (saveErr) {
    console.error("Failed to save run:", saveErr)
  }
}